import React from 'react'

const TreatmentSection = ({ heading, description, imageUrl, reverse, className }) => {
    return (
        <div className={` ${className} ${reverse && "flex-row-reverse max-sm:flex-col"} max-sm:flex-col flex items-center justify-between px-[4vw] py-[64px] max-lg:flex-col gap-[90px] max-lg:gap-[32px]`}>
            <div className="flex flex-col gap-[16px] max-lg:items-center w-full">
                <h2 className="text-[#101828] text-[30px] font-[600] max-lg:text-center">
                    {heading}
                </h2>
                <p className="text-[18px] text-[#1D1D1B] max-w-[100%] max-lg:text-[16px] max-lg:text-center">
                    {description}
                </p>
            </div>
            <div className={`w-full flex items-end justify-end ${reverse && "!items-start !justify-start max-sm:!items-center max-sm:!justify-center"}`}>
                <img className="max-w-[650px] max-xl:max-w-[480px] max-sm:max-w-full rounded-[10px] border-[3px] border-[#101828]" src={imageUrl} alt="" />
            </div>
        </div>
    )
}

const TreatmentTypes = () => {
    return (
        <div className='w-full max-w-[1980px] sm:py-[96px] py-[48px] sm:gap-[96px] gap-[48px]'>

            <div className="flex flex-col gap-[20px] items-center w-full">
                <div className="flex flex-col gap-[12px] items-center">
                    <span className='text-[#1C9943] font-[600] text-center'>
                        Inner Health
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                        Explore The World of inner Health
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Navigating the Path to Personal Well-being
                </span>
            </div>

            <TreatmentSection
                heading={'#1'}
                imageUrl={'/images/treatment/treatment1.png'}
                description={'This type of massage is used to treat a variety of musculoskeletal issues. It involves the application of deep localised pressure to soft tissue structures to break up adhesions/scar tissue following injury and reduce tension. It also supports healing by increasing blood flow to damaged structures e.g. muscle strains'}
            />

            <TreatmentSection
                heading={'#2'}
                reverse={true}
                description={'This is the application of specific osteopathic mobilisations to reduce joint stiffness, alleviate pain and ultimately aid restoration of function'}
                imageUrl={'/images/treatment/treatment2.png'}
            />

            <TreatmentSection
                heading={'#3'}
                description={"Western Medical acupuncture derives from ancient Chinese medicine and is used to compliment rehabilitation amongst most health professionals. It involves the use of fine metallic needles placed in specific or non-specific locations, to provide pain relieving benefits by stimulating the nervous system and releasing the body’s natural opioids or endorphins. Acupuncture also works to increase blood flow to localised sites to stimulate /promote the healing process through micro trauma. It is also effective in reducing muscular tension or trigger points by gentle manipulating/stimulating needles inserted into sensitive regions, using a variety techniques. Acupuncture is currently advocated for chronic pain for example stubborn Tendinopathies or long-standing back and neck issues."}
                imageUrl={'/images/treatment/treatment3.png'}
            />

            <TreatmentSection
                heading={'#4'}
                reverse={true}
                description={'This is the application of specific osteopathic mobilisations to reduce joint stiffness, alleviate pain and ultimately aid restoration of function. This is the application of suction cups to stimulate soft tissue to address ache and pains. This is particularly helpful in promoting healing by enhancing circulation of blood to reduce toxins and inflammatory properties; reduce muscle tension ultimately improving pain control.'}
                imageUrl={'/images/treatment/treatment4.png'}
            />

        </div>
    )
}

export default TreatmentTypes